module.exports = __webpack_public_path__ + "img/brand-banner.7343c7c1.png";